import React from 'react';

import {
  SkeletonCard,
  SkeletonLine,
  SkeletonRow,
  SkeletonCircle,
} from './ServiceListStates.styles';

export const ServiceListSkeleton: React.FC = () => (
  <>
    {[1, 2, 3].map((i) => (
      <SkeletonCard key={i}>
        <SkeletonRow>
          <SkeletonLine width="30%" height="16px" />
          <SkeletonCircle size="36px" />
        </SkeletonRow>
        <SkeletonLine width="70%" />
        <SkeletonLine width="50%" />
        <SkeletonRow sx={{ mt: 1 }}>
          <SkeletonLine width="60px" height="24px" />
          <SkeletonLine width="60px" height="24px" />
        </SkeletonRow>
        <SkeletonRow sx={{ mt: 1 }}>
          <SkeletonLine width="60%" />
          <SkeletonCircle />
        </SkeletonRow>
      </SkeletonCard>
    ))}
  </>
);
